import React, { Component } from 'react';
import '../../components/css/popupstyle.css';
import $ from 'jquery';
import loader from '../../components/css/dark/img/loader.gif';

class RequestGroupNumber extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userdata: JSON.parse(localStorage.getItem('user')),
            header: this.props.text,
            AddedGroup: [],
            PreFix: [],
            DefaultPrefix: 'HDRX'
        };
       
    }
    componentDidMount() {
        this.Get_Prefix_List('N/A', this.state.userdata.wholesaler);
    }

    Get_Prefix_List(Prefix, WhName) {
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
                body: JSON.stringify({ Prefix, WhName })
            };
            return fetch(`/api/ws/GroupNumber_Prefix`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        this.setState({ PreFix: apidata });
                        if (apidata.length>0) {
                            this.setState({ DefaultPrefix: apidata[0].value });
                        }
                    }
                    catch (error) {
                    }

                });
        }
        catch (error) {
        }
    }

    HandlePrefixSelectTag = e => {
        this.setState({ DefaultPrefix: e.target.value });
    }


    handleOk = () => {
        this.setState({ AddedGroup: [] });
        let requestGroupName = $("input[name=groupNumber]").val();
        if (requestGroupName == '' || requestGroupName == null || requestGroupName == undefined) {
            $(".requestGroup .error").text('Please enter group name');
        } else {
            $(".requestGroup .error").text(' ');
            this.Process_Adding_GroupNumbers(requestGroupName, this.state.userdata.wholesaler);
        }
    }

    Process_Adding_GroupNumbers(Prefix, WhName) {
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Prefix, WhName })
            };
            return fetch(`/api/ws/RequestGroupNumber`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        if (apidata.length > 0) {
                            if (apidata[0].code != "-1") {
                                if (apidata[0].groups.length > 0) {
                                    $(".requestGroup .error").addClass('SuccessGreen').text(apidata[0].message);// success
                                    this.setState({ AddedGroup: apidata[0].groups });
                                }
                                else {
                                    $(".requestGroup .error").text(apidata[0].message);
                                }
                            }
                            else {
                                $(".requestGroup .error").text(apidata[0].message);
                            }
                        }
                        else {
                            $(".requestGroup .error").text('Error Please try later.');
                        }
                    }
                    catch (error) {
                        $(".requestGroup .error").text('Error Please try later.');
                    }
                });
        }
        catch (error) {
        }
    }

    handleResponse(response) {
        return response.text().then(text => {
            try {
                const data = text && JSON.parse(text);
                return data;
            }
            catch (error) {
                const data = [];
                return data;
            }
        });
    }

    handleCancel() {
        $(".requestGroup .error").text(' ');
    }

    render() {
        return (
            <div className='popup'>
                <div className='popup_inner rep'>
                    <div className='popup_scroll'>

                        <h1>{this.state.header}<button onClick={this.props.closePopup}>X</button></h1>

                        <div className="requestGroup">

                            <div className="text">
                                <p></p>
                            </div>
                            <div className="content">
                                {
                                    this.state.PreFix.length > 1 ?
                                        <select onChange={this.HandlePrefixSelectTag}>
                                            {
                                                this.state.PreFix.map((e1, i1) => {
                                                    return (<option value={e1.value}>{e1.value}</option>)
                                                })
                                            }
                                        </select> : null
                                }
                                <input type="hidden" className="form-control" name="groupNumber" defaultValue={this.state.DefaultPrefix} />

                                <div className="error"></div>

                                <div class="pop-btn">
                                    <button class="btn" onClick={this.handleOk}>Ok</button><button class="btn cancel" onClick={this.props.closePopup}>Cancel</button>
                                </div>

                            </div>

                            <div className="groupNumber">
                                {
                                    this.state.AddedGroup.length > 0 ?
                                        <ul>
                                            {
                                                this.state.AddedGroup.map((value, index) => {
                                                    return (<li>{value.groupNumber}</li>)
                                                })
                                            }
                                        </ul> : null
                                }
                            </div>


                        </div>



                    </div>
                </div>
            </div>
        )
    }
}

export default RequestGroupNumber;